import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form,  Button, Message} from 'semantic-ui-react'
import _ from 'lodash';
import TitDer from '../../../components/funcionales/titder';

// import SeguroPermite from '../../../components/funcionales/seguropermite'
import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';


import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'
var QRCode = require('qrcode');

const DetalleEmpNivel1 = props => {
  // console.log(props.elemento)
  return (
    <option style={props.styles.input}>{props.elemento.descrEmpresa}</option>
  )
};

const ListaEmp = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="descrEmpresa" id="miLista" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar Empresa...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetalleEmpNivel2 = props => {
  // console.log(props.elemento)
  return (
    <option style={props.styles.input}>{props.elemento.nombreUsuario}</option>
  )
};

const ListaTri = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleEmpNivel2 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="nombreUsuario" id="miLista1" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar Tribologo...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

// const DetallePl = ({elemento}) => {
//   // let urlSlcm = 'https://montserratslcm.com/api/imgorden/'
//   let canvas = document.createElement("canvas");
//   QRCode.toCanvas(canvas, elemento.codigoQR)
//   let imgSourceQR = canvas.toDataURL("image/svg");
//   return(
//     <tr className='' >
//     {/* <tr className=''> */}
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEmpresa}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMetodo}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrTarea}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ruta}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numeroOrden}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estadoOrden}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.realizado}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaProg?elemento.fechaProg.substr(0, 10):""}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaReal?elemento.fechaReal.substr(0, 10):""}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrLubricante}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidadReal}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.abrevUnidad}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.minutosReal}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.usuarioCreate}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.nombreUsuarioReal}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ObservacionesReal}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em'}}>
//            <img src={imgSourceQR} alt="Código QR" />          
//       </td>
//     </tr>
//   )
// };

// const ListaPl = ({list}) => {
//   const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} 
//         key={i} />);
//   return(
//     <tbody className=''>
//       {nivel1Detalle}
//     </tbody>
//   )
// };

// const DetalleHa = ({elemento}) => {
//   let imgSourceQR = null
//   if(elemento.codigoQR){
//     let canvas = document.createElement("canvas");
//     QRCode.toCanvas(canvas, elemento.codigoQR)
//     let imgSourceQR = canvas.toDataURL("image/svg"); 
//   } 
//   return(
//     <tr className=''>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEmpresa}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMetodo}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrHallazgo?elemento.descrHallazgo:''}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ruta}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numeroOrden}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estadoOrden}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.realizado}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaProg?elemento.fechaProg.substr(0, 10):""}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.realizado==="S"?elemento.fechaReal.substr(0, 10):""}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrLubricante?elemento.descrLubricante:''}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidadReal?elemento.cantidadReal:0}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.abrevUnidad?elemento.abrevUnidad:''}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.minutosReal?elemento.minutosReal:0}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.usuarioCreate}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.nombreUsuarioReal?elemento.nombreUsuarioReal:''}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ObservacionesReal?elemento.ObservacionesReal:''}</td>
//       <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em'}}>
//            <img src={imgSourceQR} alt="Código QR" />          
//       </td>
//     </tr>
//   )
// };

// const ListaHa = ({list}) => {
//   const nivel1Detalle = list.map((elemento, i) => <DetalleHa elemento={elemento} 
//         key={i}/>);
//   return(
//     <tbody className=''>
//       {nivel1Detalle}
//     </tbody>
//   )
// };

class ProgBitacoraNueva2 extends React.Component {
  state={list: [], listH: [],
    argsDocum: {desde: this.props.fechaHoy, hasta: this.props.fechaFin, descrEmpresa: "Seleccionar Empresa...", 
                     nombreUsuario: "Seleccionar Tribologo..."}, 
    argsBuscInf: {}, idListaP: [], inicio: 'S',
    argsQuery2: `{$project: {_id: 1, descrEmpresa: 1, descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, descrComponente: 1, descrMecanismo: 1, 
      descrMetodo: 1, descrTarea: 1, descrHallazgo: 1, ruta: 1, numeroOrden: 1, estadoOrden: 1, realizado: 1, fechaProg: 1, fechaReal: 1, horaReal: 1,
      descrLubricante: 1, cantidadReal: 1, abrevUnidad: 1, minutosReal: 1, usuarioCreate: 1, nombreUsuarioReal: 1, 
      imgAntes: 1, imgDespues: 1, observaciones: 1, observacionesReal: 1}},   
      {$lookup: {from: 'usuarios', localField: 'usuarioCreate', foreignField: 'email', as: 'usuario'}},
        {$unwind: '$usuario'},
      {$project: {_id: 1, descrEmpresa: 1, descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, descrComponente: 1, descrMecanismo: 1, 
        descrMetodo: 1, descrTarea: 1, descrHallazgo: 1, ruta: 1, numeroOrden: 1, estadoOrden: 1, realizado: 1, fechaProg: 1, fechaReal: 1, horaReal: 1,
        descrLubricante: 1, cantidadReal: 1, abrevUnidad: 1, minutosReal: 1, nombreUsuarioReal: 1, 
        imgAntes: 1, imgDespues: 1, observaciones: 1, observacionesReal: 1, usuarioCreate: '$usuario.nombreUsuario'}}`,

    argsQuery: `
  //   {$lookup: {
  //     from: "plantas",
  //     let: { empresa: "$descrEmpresa", planta: "$descrPlanta", seccion: "$descrSeccion", equipo: "$descrEquipo", componente: "$descrComponente", mecanismo: "$descrMecanismo" },
  //     pipeline: [
  //       {
  //         $match: {
  //           $expr: {
  //             $and: [
  //               { $eq: ["$descrEmpresa", "$$empresa"] },
  //               { $eq: ["$descrPlanta", "$$planta"] }
  //             ]
  //           }
  //         }
  //       },
  //       { $unwind: "$secciones" },
  //       {
  //         $match: {
  //           $expr: { $eq: ["$secciones.descrSeccion", "$$seccion"] }
  //         }
  //       },
  //       { $unwind: "$secciones.equipos" },
  //       {
  //         $match: {
  //           $expr: { $eq: ["$secciones.equipos.descrEquipo", "$$equipo"] }
  //         }
  //       },
  //       { $unwind: "$secciones.equipos.componentes" },
  //       {
  //         $match: {
  //           $expr: { $eq: ["$secciones.equipos.componentes.descrComponente", "$$componente"] }
  //         }
  //       },
  //       { $unwind: "$secciones.equipos.componentes.mecanismos" },
  //       {
  //         $match: {
  //           $expr: { $eq: ["$secciones.equipos.componentes.mecanismos.descrMecanismo", "$$mecanismo"] }
  //         }
  //       },
  //       {
  //         $project: {
  //           codigoQR: "$secciones.equipos.componentes.mecanismos.codigoQR"
  //         }
  //       }
  //     ],
  //     as: "mecanismoData"
  //   }
  // },
  // {$unwind: {
  //     path: "$mecanismoData",
  //     preserveNullAndEmptyArrays: true
  // }},
  {$project: {
      _id: 1, descrEmpresa: 1, descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, descrComponente: 1, descrMecanismo: 1,
      descrMetodo: 1, descrTarea: 1, descrHallazgo: 1, ruta: 1, numeroOrden: 1, estadoOrden: 1, realizado: 1, fechaProg: 1, fechaReal: 1, horaReal: 1,
      descrLubricante: 1, cantidadReal: 1, abrevUnidad: 1, minutosReal: 1, usuarioCreate: 1, nombreUsuarioReal: 1, 
      imgAntes: 1, imgDespues: 1, observaciones: 1, observacionesReal: 1
      , codigoQR: 1
  }},
  {$lookup: {from: 'usuarios', localField: 'usuarioCreate', foreignField: 'email', as: 'usuario'}},
        {$unwind: '$usuario'},
      {$project: {_id: 1, descrEmpresa: 1, descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, descrComponente: 1, descrMecanismo: 1, 
        descrMetodo: 1, descrTarea: 1, descrHallazgo: 1, ruta: 1, numeroOrden: 1, estadoOrden: 1, realizado: 1, fechaProg: 1, fechaReal: 1, horaReal: 1,
        descrLubricante: 1, cantidadReal: 1, abrevUnidad: 1, minutosReal: 1, nombreUsuarioReal: 1, 
        imgAntes: 1, imgDespues: 1, observaciones: 1, observacionesReal: 1, codigoQR: 1, usuarioCreate: '$usuario.nombreUsuario'}}`

    // argsQuery1: `{"$unwind": "$secciones"}, 
    //   {"$unwind": "$secciones.equipos"}, 
    //   {"$unwind": "$secciones.equipos.componentes"}, 
    //   {"$unwind": "$secciones.equipos.componentes.mecanismos"}, 
    //   {$project: {_id: 1, descrEmpresa: 1, descrPlanta: 1, descrSeccion: '$secciones.descrSeccion',
    //     descrEquipo: '$secciones.equipos.descrEquipo',
    //     descrComponente: '$secciones.equipos.componentes.descrComponente',
    //     descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
    //     codigoQR: '$secciones.equipos.componentes.mecanismos.codigoQR'}}`
  }

handleChange = async (ev, indice) => {
  // document.body.style.cursor = 'wait'

  if(ev.target.name==="descrEmpresa"||ev.target.name==="nombreUsuario"||ev.target.name==="desde"||ev.target.name==="hasta"){
    const argsDocum = this.state.argsDocum
    argsDocum[ev.target.name] = ev.target.value
    this.setState({argsDocum});
    console.log(argsDocum)
    if(argsDocum.descrEmpresa!=='Seleccionar Empresa...' && argsDocum.nombreUsuario!=='Seleccionar Tribologo...'){
      let argsBuscar=`alimSistema: 'S', realizado: 'S'`
      argsBuscar += `, $or: [
        { 'descrMetodo': {$ne: 'Hallazgo'}},
        { 'descrMetodo': 'Hallazgo', 'descrTarea': 'Tomar muestra'}
      ]`
      if(ev.target.name==="descrEmpresa"){
        argsBuscar += `, 'descrEmpresa': '${ev.target.value}', nombreUsuarioReal: '${argsDocum.nombreUsuario}', fechaReal: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') }`
      }
      if(ev.target.name==="nombreUsuario"){
        argsBuscar += `, 'descrEmpresa': '${argsDocum.descrEmpresa}', nombreUsuarioReal: '${ev.target.value}', fechaReal: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') }`
      }
      if(ev.target.name==="desde"){
        argsBuscar += `, 'descrEmpresa': '${argsDocum.descrEmpresa}', nombreUsuarioReal: '${argsDocum.nombreUsuario}', fechaReal: { $gte: new Date('${ev.target.value}'), $lte: new Date('${argsDocum.hasta}') }`
      }
      if(ev.target.name==="desde"){
        argsBuscar += `, 'descrEmpresa': '${argsDocum.descrEmpresa}', nombreUsuarioReal: '${argsDocum.nombreUsuario}', fechaReal: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${ev.target.value}') }`
      }
      let argsBuscProg = ""
      argsBuscProg = {tipoqry: `[{$match: {${argsBuscar}}}, ${this.state.argsQuery}]`}


      let argsBuscarH=`'descrMetodo': 'Hallazgo', 'descrTarea': {$ne: 'Tomar muestra'}`
      if(ev.target.name==="descrEmpresa"){
        argsBuscarH += `, $or: [
          { 'descrEmpresa': '${ev.target.value}', nombreUsuario: '${argsDocum.nombreUsuario}', fechaProg: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') } },
          { 'realizado': 'S', 'descrEmpresa': '${ev.target.value}', nombreUsuarioReal: '${argsDocum.nombreUsuario}', fechaReal: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') } }
        ]`
      }
      if(ev.target.name==="nombreUsuario"){
        argsBuscarH += `, $or: [
          { 'descrEmpresa': '${argsDocum.descrEmpresa}', nombreUsuario: '${ev.target.value}', fechaProg: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') } },
          { 'realizado': 'S', 'descrEmpresa': '${argsDocum.descrEmpresa}', nombreUsuarioReal: '${ev.target.value}', fechaReal: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${argsDocum.hasta}') } }
        ]`
      }
      if(ev.target.name==="desde"){
        argsBuscarH += `, $or: [
          { 'descrEmpresa': '${argsDocum.descrEmpresa}', nombreUsuario: '${argsDocum.nombreUsuario}', fechaProg: { $gte: new Date('${ev.target.value}'), $lte: new Date('${argsDocum.hasta}') } },
          { 'realizado': 'S', 'descrEmpresa': '${argsDocum.descrEmpresa}', nombreUsuarioReal: '${argsDocum.nombreUsuario}', fechaReal: { $gte: new Date('${ev.target.value}'), $lte: new Date('${argsDocum.hasta}') } }
        ]`
      }
      if(ev.target.name==="hasta"){
        argsBuscarH += `, $or: [
          { 'descrEmpresa': '${argsDocum.descrEmpresa}', nombreUsuario: '${argsDocum.nombreUsuario}', fechaProg: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${ev.target.value}') } },
          { 'realizado': 'S', 'descrEmpresa': '${argsDocum.descrEmpresa}', nombreUsuarioReal: '${argsDocum.nombreUsuario}', fechaReal: { $gte: new Date('${argsDocum.desde}'), $lte: new Date('${ev.target.value}') } }
        ]`
      }
      let argsBuscProgH = ""
      argsBuscProgH = {tipoqry: `[{$match: {${argsBuscarH}}}, ${this.state.argsQuery}]`}
      console.log(argsBuscProg)

      if(2>1){
        if(this.props.allOrdenRtes.allOrdenRtes){
          console.log(argsBuscProg)
          let {data} = await this.props.allOrdenRtes.refetch(argsBuscProg)
          let list = await data.allOrdenRtes
          this.setState({list})
        }
      }
      if(2>1){
        if(this.props.allOrdenRtesH.allOrdenRtes){
          let {data} = await this.props.allOrdenRtesH.refetch(argsBuscProgH)
          let listH = await data.allOrdenRtes
          this.setState({listH})
        }
      }
      // this.props.allOrdenRtes.refetch()
    }
  }
}

  handleCopiaInfPdf = async (ev, lista, listaH)=>{
  const argsDocum = this.state.argsDocum
  if(argsDocum.descrEmpresa!=='Seleccionar Empresa...' && argsDocum.nombreUsuario!=='Seleccionar Tribologo...'){
    document.body.style.cursor = 'wait'

    let cargoUsu='', mailUsu='', telefonoUsu='', firmaUsu='', logo=''
    let urlSlcm = 'https://montserratslcm.com/api/logos/'

    if(this.props.allUsuariosRtes1.allUsuariosRtes){
      let argsBuscarUsu = {tipoqry: `[{$match: {'nombreUsuario': '${argsDocum.nombreUsuario}'}}]`}
      let {data} = await this.props.allUsuariosRtes1.refetch(argsBuscarUsu)
      cargoUsu = data.allUsuariosRtes[0].cargo?data.allUsuariosRtes[0].cargo:''
      mailUsu = data.allUsuariosRtes[0].email?data.allUsuariosRtes[0].email:''
      telefonoUsu = data.allUsuariosRtes[0].telefono?data.allUsuariosRtes[0].telefono:''
      firmaUsu = data.allUsuariosRtes[0].archivoFirma?data.allUsuariosRtes[0].archivoFirma:''
    }
    let dirEmpresa = 'images/logos/' + logo
    let archivoFirma=''
    if (firmaUsu!==''){
      archivoFirma=urlSlcm + firmaUsu
    }
    let hallazgos = []
    let hallazgosRep=0, hallazgosEjec=0
    if(listaH.length>0){
      hallazgos=listaH

      let argsBuscarH=`'descrMetodo': 'Hallazgo', 'descrTarea': {$ne: 'Tomar muestra'}`
      argsBuscarH += `, 'descrEmpresa': '${this.state.argsDocum.descrEmpresa}', nombreUsuario: '${this.state.argsDocum.nombreUsuario}', fechaProg: { $gte: new Date('${this.state.argsDocum.desde}'), $lte: new Date('${this.state.argsDocum.hasta}') }`
      let argsBuscProgH = ""
      argsBuscProgH = {tipoqry: `[{$match: {${argsBuscarH}}}, ${this.state.argsQuery}]`}
      let {data} = await this.props.allOrdenRtesH1.refetch(argsBuscProgH)
      let registros = await data.allOrdenRtes
      if(registros.length>0){
        hallazgosRep=registros.length
      }

      this.props.allOrdenRtesH.refetch()
      argsBuscarH=`'descrMetodo': 'Hallazgo', 'descrTarea': {$ne: 'Tomar muestra'}, 'realizado': 'S'`
      argsBuscarH += `, 'descrEmpresa': '${this.state.argsDocum.descrEmpresa}', nombreUsuario: '${this.state.argsDocum.nombreUsuario}', fechaReal: { $gte: new Date('${this.state.argsDocum.desde}'), $lte: new Date('${this.state.argsDocum.hasta}') }`
      argsBuscProgH = ""
      argsBuscProgH = {tipoqry: `[{$match: {${argsBuscarH}}}, ${this.state.argsQuery}]`}
      console.log(argsBuscProgH)
      if(2>1){
        let {data} = await this.props.allOrdenRtesH2.refetch(argsBuscProgH)
        let registrosE = await data.allOrdenRtes
        if(registrosE.length>0){
          hallazgosEjec=registrosE.length
        }
      }
    }

    if(lista.length>0||hallazgos.length>0){
      let dirSlcm = 'images/logos/LCMSAS.png'
      
      let doc = new jsPDF({orientation: 'l', unit: 'mm', format: 'letter'})
      let widthDoc = (doc.internal.pageSize.width)
      let heightDoc = (doc.internal.pageSize.height)
      let logo = ""
      if(this.props.allEmpresaRtes1.allEmpresaRtes){

        let argsBuscarEmp = {tipoqry: `[{$match: {'descrEmpresa': '${argsDocum.descrEmpresa}'}}]`}
        let {data} = await this.props.allEmpresaRtes1.refetch(argsBuscarEmp)
        logo = await data.allEmpresaRtes[0].logo
      }
      let dirEmpresa = 'images/logos/' + logo
      let response = await this.props.fecha({
        variables: {}
      });

      const {fechaHoraHoy} = response.data.fecha
      let tablaRte = [], tablaRteH = []
      let nomEmpresa = ''
      let ancho=widthDoc-24

      let posic=27
      doc.rect(12, posic, widthDoc-24, 5)   
      doc.setFontSize(8);
      doc.text('INFORMACION DE TRABAJOS REALIZADOS DE ' + argsDocum.desde + ' A ' + argsDocum.hasta, 85, 30, 'left')

      let tablaRteF = []
      let argsUpd = []

      argsUpd.push('');
      argsUpd.push('');
      tablaRteF.push(argsUpd) 
      argsUpd = []
      argsUpd.push('');
      argsUpd.push('');
      tablaRteF.push(argsUpd) 
      argsUpd = []
      argsUpd.push('');
      argsUpd.push('');
      tablaRteF.push(argsUpd) 
      argsUpd = []  
      argsUpd.push('FIRMA');
      argsUpd.push('FIRMA');
      tablaRteF.push(argsUpd) 
      argsUpd = []
      argsUpd.push('Nombre: ' +argsDocum.nombreUsuario);
      argsUpd.push('Nombre: ');
      tablaRteF.push(argsUpd) 
      argsUpd = []
      argsUpd.push('Cargo: ' + cargoUsu);
      argsUpd.push('Tareas realizadas: ' + new Intl.NumberFormat('de-DE').format(Math.round(lista.length)));
      tablaRteF.push(argsUpd) 
      argsUpd = []
      argsUpd.push('email: ' + mailUsu);
      argsUpd.push('Hallzgos reportados: ' + new Intl.NumberFormat('de-DE').format(Math.round(hallazgosRep)));
      tablaRteF.push(argsUpd) 
      argsUpd = []
      argsUpd.push('Teléfono: ' + telefonoUsu);
      argsUpd.push('Hallazgos ejecutados: ' + new Intl.NumberFormat('de-DE').format(Math.round(hallazgosEjec)));
      tablaRteF.push(argsUpd) 
      argsUpd = []
      
      doc.autoTable({
        startY: 32,
        rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
        showHead: 'everyPage',
        tableLineColor: "black",
        tableLineWidth: 0.1,
        styles: {
          fontSize: 6,
          lineColor: "black",
          lineWidth: 0.1,
          valign: "top",
        },
        headStyles: {
          fillColor: "#E9E4F0",
          textColor: "black",
          halign: "center",
          valign: "top",
          cellPadding: 1,
          fontStyle: "bold",
          fontSize: 6
        },
        bodyStyles: {
          // fillColor: "#E9E4F0",
          fillColor: "white",
          textColor: "black",
          halign: "left",
          minCellHeight: 1
        },
        columnStyles: {
          0: {cellWidth: ancho*0.499},
          1: {cellWidth: ancho*0.499},
        },

        didParseCell(data) {
          if(data.row.index !== -1 && data.section==='body'){
            data.cell.styles.minCellHeight = 1
            data.cell.styles.fillColor = "white"
            data.cell.styles.fontStyle = "normal"
          }
          if(data.row.index === 0 && data.section==='body'){
            if(data.column.index === 0 || data.column.index === 1){
              data.cell.rowSpan = 3
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'center'
            }
          }
          if(data.row.index === 3 && data.section==='body'){
            if(data.column.index === 0 || data.column.index === 1){
              data.cell.styles.halign = 'center'
              data.cell.styles.valign = 'center'
            }
          }
        },

        didDrawCell: (data) => {
          //imagenes en autoTable
          //https://github.com/simonbengtsson/jsPDF-AutoTable/issues/93
        if(data.row.index===-1){
        console.log("ojoooo")
        }

        if(data.row.index === 0 && data.section==='body' && data.column.index === 0){
          if(archivoFirma!==''){
            let imgSourceCB = new Image();
            imgSourceCB.src = archivoFirma;
            doc.convertStringToImageData(imgSourceCB)
            doc.addImage(imgSourceCB, 'PNG', data.cell.x + 36.5, data.cell.y, 50, 13);
          }
        }


        },
        alternateRowStyles: {
          textColor: "black"
        },
        head: [["TRIBOLOGO", "EMPRESA"]],
        body: tablaRteF,
        margin: {top: 100, left: 12, right: 12, bottom: 25}
      })
      let registroQR = []

      if(lista.length>0){
        for (var i = 0; i < lista.length; i++) {
          nomEmpresa=lista[i].descrEmpresa

//           let argsBuscarQR=`'descrEmpresa': '${this.state.argsDocum.descrEmpresa}', 'descrPlanta': '${lista[i].descrPlanta}', 'descrSeccion': '${lista[i].descrSeccion}', 'descrEquipo': '${lista[i].descrEquipo}', 'descrComponente': '${lista[i].descrComponente}', 'descrMecanismo': '${lista[i].descrMecanismo}'`
//           let argsBuscMec = ""
//           argsBuscMec = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscarQR}}}]`}
//           console.log(argsBuscMec)
//           let {data} = await this.props.allPlantaRtesQR.refetch(argsBuscMec)
//           console.log(this.props.allPlantaRtesQR)
//           let registros = await data.allPlantaRtes
//           console.log(registros)
//           registroQR[i] = registros[0].codigoQR
// console.log(registroQR[i])
          let argsUpd = []
          
          argsUpd.push(lista[i].fechaReal?lista[i].fechaReal.substr(0, 10) + " " +lista[i].horaReal + ":00":"")
          argsUpd.push(lista[i].descrPlanta)
          argsUpd.push(lista[i].descrSeccion)
          argsUpd.push(lista[i].descrEquipo)
          argsUpd.push(lista[i].descrComponente)
          argsUpd.push(lista[i].descrMecanismo)
          argsUpd.push("")
          argsUpd.push(lista[i].descrMetodo)
          argsUpd.push(lista[i].descrMetodo==='Hallazgo'?lista[i].descrHallazgo?lista[i].descrHallazgo:'':lista[i].descrTarea)
          argsUpd.push(lista[i].descrLubricante)
          argsUpd.push(lista[i].cantidadReal)
          argsUpd.push(lista[i].abrevUnidad)
          argsUpd.push(lista[i].observacionesReal?lista[i].observacionesReal:'')
          argsUpd.push(lista[i].nombreUsuarioReal?lista[i].nombreUsuarioReal:'')
          tablaRte.push(argsUpd) 
          argsUpd = []

          if(i===lista.length-1){
            doc.setDrawColor('black');
            doc.setFillColor('#E9E4F0');
            doc.rect(12, 87, ancho, 5)
            doc.setFillColor('#bdc3c7');
            doc.setFontSize(8);
            doc.setFontStyle('bold');
            doc.text(`TAREAS DE LUBRICACION`, (widthDoc/2)-11, 90)

            let indice = 0
            doc.autoTable({
              startY: 92,
              rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
              showHead: 'everyPage',
              tableLineColor: "black",
              tableLineWidth: 0.1,
              styles: {
                fontSize: 6,
                lineColor: "black",
                lineWidth: 0.1,
                valign: "top",
              },
              headStyles: {
                fillColor: "#E9E4F0",
                textColor: "black",
                halign: "center",
                valign: "top",
                cellPadding: 1,
                fontStyle: "bold",
                fontSize: 6
              },
              bodyStyles: {
                fillColor: "white",
                textColor: "black",
                halign: "center",
                minCellHeight: 3
              },
              columnStyles: {
                0: {cellWidth: ancho*0.0825},
                1: {cellWidth: ancho*0.075},
                2: {cellWidth: ancho*0.075},
                3: {cellWidth: ancho*0.075},
                4: {cellWidth: ancho*0.075},
                5: {cellWidth: ancho*0.075},
                6: {cellWidth: ancho*0.045},
                7: {cellWidth: ancho*0.045},
                8: {cellWidth: ancho*0.045},
                9: {cellWidth: ancho*0.075},
                10: {cellWidth: ancho*0.0275},
                11: {cellWidth: ancho*0.0275},
                12: {cellWidth: ancho*0.215},
                13: {cellWidth: ancho*0.045},
                },

              didParseCell(data) {
                if(data.row.index !== -1 && data.section==='body'){
                  data.cell.styles.minCellHeight = 3
                  data.cell.styles.fillColor = "white"
                  data.cell.styles.fontStyle = "normal"
                }
              },

              didDrawCell: (data) => {
                if(data.row.index !== -1 && data.section==='body' && data.column.index === 0){
                  if(data.row.index===0){
                    indice = 0
                  }else{
                    indice += 1
                  }
                }

                if(data.row.index !== -1 && data.section==='body' && data.column.index === 6){
                  // console.log(registroQR[indice])
                  if(lista[indice].codigoQR){
                    let canvas = document.createElement("canvas");
                    QRCode.toCanvas(canvas, lista[indice].codigoQR)
                    let imgSourceQR = canvas.toDataURL("image/svg");
                    doc.addImage(imgSourceQR, 'svg', data.cell.x + 0.5, data.cell.y + 1, 10, 10);
                  }
                }

                if(data.row.index===-1){
                console.log("ojoooo")
                }
              },
              alternateRowStyles: {
                textColor: "black"
              },
              head: [["Fecha Hora ejec", "Planta", "Sección", "Equipo", "Componente", "Mecanismo", "QR", "Método", "Tarea", "Lubricante", "Cant.", "Und", "Observaciones de ejecución", "Reporta"]],
              body: tablaRte,
              margin: {top: 40, left: 12, right: 12, bottom: 25}
            })
            tablaRte = []
          }    
        }
      }

      // let posic = 90
      let heightDisponible=heightDoc-80

      if(hallazgos.length>0){
        if(lista.length>0){
          doc.addPage()
        }
        tablaRte = []

        for (var i = 0; i < hallazgos.length; i++) {
          nomEmpresa=hallazgos[i].descrEmpresa
          let argsUpd = []
          let heightLineaItem=0, lineaMayor=1
          let parrafoOb=[], parrafoObs=[], parrafoRe=[]

          let parrafoPL = hallazgos[i].descrPlanta.split("\n")
          let parrafoSe = hallazgos[i].descrSeccion.split("\n")
          let parrafoEq = hallazgos[i].descrEquipo.split("\n")
          let parrafoCo = hallazgos[i].descrComponente.split("\n")
          let parrafoMe = hallazgos[i].descrMecanismo.split("\n")
          let parrafoHa = hallazgos[i].descrHallazgo?hallazgos[i].descrHallazgo.split("\n"):''
          if(hallazgos[i].observaciones){
            parrafoOb = hallazgos[i].observaciones.split("\n")
          }
          if(hallazgos[i].observacionesReal){
            parrafoObs = hallazgos[i].observacionesReal.split("\n")
          }
          if(hallazgos[i].nombreUsuarioReal){
            parrafoRe = hallazgos[i].nombreUsuarioReal.split("\n")
          }
  
          parrafoPL.forEach((texto, ii) => {   
            let lineasPl = doc.splitTextToSize(texto, 10)
            if(texto){
              if(lineasPl.length>lineaMayor){
                lineaMayor=lineasPl
              }
            }
          })
          parrafoSe.forEach((texto, ii) => {   
            let lineasSe = doc.splitTextToSize(texto, 10)
            if(texto){
              if(lineasSe.length>lineaMayor){
                lineaMayor=lineasSe
              }
            }
          })
          parrafoEq.forEach((texto, ii) => {   
            let lineasEq = doc.splitTextToSize(texto, 10)
            if(texto){
              if(lineasEq.length>lineaMayor){
                lineaMayor=lineasEq
              }
            }
          })
          parrafoCo.forEach((texto, ii) => {   
            let lineasCo = doc.splitTextToSize(texto, 10)
            if(texto){
              if(lineasCo.length>lineaMayor){
                lineaMayor=lineasCo
              }
            }
          })
          parrafoMe.forEach((texto, ii) => {   
            let lineasMe = doc.splitTextToSize(texto, 10)
            if(texto){
              if(lineasMe.length>lineaMayor){
                lineaMayor=lineasMe
              }
            }
          })
          parrafoHa.forEach((texto, ii) => {   
            let lineasHa = doc.splitTextToSize(texto, 10)
            if(texto){
              if(lineasHa.length>lineaMayor){
                lineaMayor=lineasHa
              }
            }
          })
          if(parrafoOb){
            parrafoOb.forEach((texto, ii) => {   
              let lineasOb = doc.splitTextToSize(texto, 10)
              if(texto){
                if(lineasOb.length>lineaMayor){
                  lineaMayor=lineasOb
                }
              }
            })
          }
          if(parrafoObs){
            parrafoObs.forEach((texto, ii) => {   
              let lineasObs = doc.splitTextToSize(texto, 10)
              if(texto){
                if(lineasObs.length>lineaMayor){
                  lineaMayor=lineasObs
                }
              }
            })
          }
          if(parrafoRe){
            parrafoRe.forEach((texto, ii) => {   
              let lineasRe = doc.splitTextToSize(texto, 10)
              if(texto){
                if(lineasRe.length>lineaMayor){
                  lineaMayor=lineasRe
                }
              }
            })
          }

          if(lineaMayor===1){
            posic+=5
            heightLineaItem=5
          }else{
            posic+=5*lineaMayor.length
            heightLineaItem=(5*lineaMayor.length)
          }            
          if(heightLineaItem>heightDisponible){
            posic=35
            heightDisponible=heightDoc-25
          }

          argsUpd.push(hallazgos[i].fechaProg?hallazgos[i].fechaProg.substr(0, 10):"")
          argsUpd.push(hallazgos[i].descrPlanta)
          argsUpd.push(hallazgos[i].descrSeccion)
          argsUpd.push(hallazgos[i].descrEquipo)
          argsUpd.push(hallazgos[i].descrComponente)
          argsUpd.push(hallazgos[i].descrMecanismo)
          argsUpd.push(hallazgos[i].descrHallazgo?hallazgos[i].descrHallazgo:'')
          argsUpd.push(hallazgos[i].observaciones?hallazgos[i].observaciones:'')
          argsUpd.push(hallazgos[i].realizado==='S'?hallazgos[i].fechaReal.substr(0, 10) + " " +hallazgos[i].horaReal + ":00":"")
          argsUpd.push(hallazgos[i].minutosReal?hallazgos[i].minutosReal:'')
          argsUpd.push(hallazgos[i].observacionesReal?hallazgos[i].observacionesReal:'')
          argsUpd.push(hallazgos[i].nombreUsuarioReal?hallazgos[i].nombreUsuarioReal:'')
          tablaRteH.push(argsUpd) 
          argsUpd = []

          if(i===hallazgos.length-1){
            if(lista.length>0){
              posic=32
            }else{
              posic=92
            }

            doc.setDrawColor('black');
            doc.setFillColor('#E9E4F0');
            doc.rect(12, posic-5, widthDoc-24, 5)
            doc.setFillColor('#bdc3c7');
            doc.setFontSize(8);
            doc.setFontStyle('bold');
            doc.text(`HALLAZGOS REPORTADOS Y EJECUTADOS`, (widthDoc/2)-31, posic-2)
            
            doc.autoTable({
              startY: posic,
              rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
              showHead: 'everyPage',
              tableLineColor: "black",
              tableLineWidth: 0.1,
              styles: {
                fontSize: 6,
                lineColor: "black",
                lineWidth: 0.1,
                valign: "top",
              },
              headStyles: {
                fillColor: "#E9E4F0",
                textColor: "black",
                halign: "center",
                valign: "top",
                cellPadding: 1,
                fontStyle: "bold",
                fontSize: 6
              },
              bodyStyles: {
                fillColor: "white",
                textColor: "black",
                halign: "center",
                minCellHeight: 3
              },
              columnStyles: {
                0: {cellWidth: ancho*0.053},
                1: {cellWidth: ancho*0.075},
                2: {cellWidth: ancho*0.075},
                3: {cellWidth: ancho*0.075},
                4: {cellWidth: ancho*0.075},
                5: {cellWidth: ancho*0.075},
                6: {cellWidth: ancho*0.075},
                7: {cellWidth: ancho*0.147},
                8: {cellWidth: ancho*0.075},
                9: {cellWidth: ancho*0.0355},
                10: {cellWidth: ancho*0.147},
                11: {cellWidth: ancho*0.075},
                },

              didParseCell(data) {
                if(data.row.index !== -1 && data.section==='body'){
                  data.cell.styles.minCellHeight = 3
                  data.cell.styles.fillColor = "white"
                  data.cell.styles.fontStyle = "normal"
                }
              },

              didDrawCell: (data) => {
                if(data.row.index===-1){
                console.log("ojoooo")
                }
              },
              alternateRowStyles: {
                textColor: "black"
              },
              // head: [["Fecha reporte", "Fecha ejec", "Hora ejec.", "Minutos operario", "Puntos", "Método", "Tarea", "tipo de hallazgo", "Estado", "Lubricante", "Cant real", "Und"]],
              head: [["Fecha reporte", "Planta", "Sección", "Equipo", "Componente", "Mecanismo", "tipo hallazgo", "Observaciones reportadas", "Fecha hora ejec.", "Minutos", "Observaciones de ejecución", "Reporta"]],
              body: tablaRteH,
              margin: {top: 40, left: 12, right: 12, bottom: 25}
            })
            tablaRteH = []
          }    
        }
      }

      const pageCount = doc.internal.getNumberOfPages();
      for(var i = 1; i <= pageCount; i++) {
        doc.setPage(i);

//ENCABEZADO DE PAGINA
        doc.setFontSize(12);
        doc.setFontType("bold");
        doc.text(argsDocum.descrEmpresa, widthDoc/2, 20, 'center')
        doc.setFontSize(8);

        let imgSource = new Image();
        try{
          imgSource.src = dirSlcm;
          doc.convertStringToImageData(imgSource)
          doc.addImage(imgSource, 'PNG', 12, 12, 55, 14);
        }catch{
          console.log("Logo de LCM no existe")
        }
        try{
          imgSource.src = dirEmpresa;
          doc.convertStringToImageData(imgSource)
          if(nomEmpresa==='CELSIA' || nomEmpresa==='CELSIA COLOMBIA' || nomEmpresa==='TRIBOS INGENIERIA SAS' || nomEmpresa==='URRA S.A .E.S.P' || nomEmpresa==='BIOENERGY'){
            doc.addImage(imgSource, 'PNG', widthDoc-49, 9, 15, 15);
          }else{
            doc.addImage(imgSource, 'PNG', widthDoc-56-12, 9, 40, 16);
          }
          // doc.addImage(imgSource, 'PNG', widthDoc-55-12, 12, 55, 17);
        }catch{
          console.log("Logo de la empresa no existe")
        }
//FIN ENCABEZADO DE PAGINA

        // if(lista.length>0){
        //   if(listaH.length>0){
        //     doc.text('Pag ' + String(i) + ' de ' + String(pageCount+1), 12, heightDoc-12, 'left')
        //     doc.text(fechaHoraHoy.substr(0, 10) + " " + fechaHoraHoy.substr(11, 5), widthDoc-50, heightDoc-12, 'left')
        //   }else{
            doc.text('Pag ' + String(i) + ' de ' + String(pageCount), 12, heightDoc-12, 'left')
            doc.text(fechaHoraHoy.substr(0, 10) + " " + fechaHoraHoy.substr(11, 5), widthDoc-50, heightDoc-12, 'left')
        //   }
        // }
      }

      

      let nameDoc = `BITACORA DE ORDENES DE TRABAJO.pdf`
      doc.save(nameDoc)

    }
    document.body.style.cursor = 'default'

  }
    //FIN Exportar a Pdf
}

  render(){
    let urlSlcm = 'https://montserratslcm.com/api/imgorden/'
    const {idListaP, argsDocum, list, listH} = this.state;
    let list1 = [], list2 = []
    let mensaje1 = "GENERAR BITACORA DE OTs EN PDF"
    if(this.props.allEmpresaRtes.allEmpresaRtes){list1 = this.props.allEmpresaRtes.allEmpresaRtes}
    list1 = list1.filter(elemento => (elemento.rutas==='Si'))
    if(this.props.allUsuariosRtes.allUsuariosRtes){list2 = this.props.allUsuariosRtes.allUsuariosRtes}
    list2 = list2.filter(elemento => (elemento.perfil.descrPerfil==='Tribologos' || elemento.perfil.descrPerfil==='Ingenieros y Coordinadores de lubricación'))
console.log(list)
console.log(listH)
    return (
      <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
      <TitDer list={list} textBoton1="Bitacora de tareas de lubricación y hallazgos" btnNuevo={"NO"} styles={this.props.styles}/>
        <Form name="form1" id="form1">
            <div className="ui five column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '20%', paddingLeft: '1.2em'}}>
                  <p style={{color: 'white', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Seleccionar
                  </p>
                  <Form.Field>
                    <ListaEmp styles={this.props.styles} list={list1} handleChange={this.handleChange} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: '20%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Desde
                  </p>
                  <Form.Field>
                    <input style={this.props.styles.input} type='date' name="desde" id="desde" value={argsDocum.desde} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '20%'}}>
                  <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    Hasta
                  </p>
                  <Form.Field>
                    <input style={this.props.styles.input} type='date' name="hasta" id="hasta" value={argsDocum.hasta} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '20%', paddingLeft: '1.2em'}}>
                  <p style={{color: 'white', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Seleccionar
                  </p>
                  <Form.Field>
                    <ListaTri styles={this.props.styles} list={list2} handleChange={this.handleChange} />
                  </Form.Field>
                </div>                
                <div className="column" style={{width: '20%'}}>
                  <p style={{color: 'white', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Ejecutar
                  </p>
                  <Button id="pdf" name="pdf" style={{...this.props.styles.confirmar, height: '2.7em'}} onClick={(ev)=>this.handleCopiaInfPdf(ev, list, listH)} fluid>
                    {mensaje1}
                  </Button>
                </div>  
              </div>
            </div>
            {/* <div>
              <div style={{height: '28em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Empresa</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Planta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sección</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Equipo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Componente</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Mecanismo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Método</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Tarea</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Ruta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Orden</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Estado</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Realiz.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fecha prog.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fecha real</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>lubricante</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cant.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Unidad</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Min.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Reporta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Ejecuta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Observaciones</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>QR Mecanismo</th>
                    </tr>
                  </thead>
                  <ListaPl list={list} />
                </table>
                <p></p>
              </div>
              <hr></hr>
            </div>
            <div>
              <div style={{height: '28em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Empresa</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Planta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sección</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Equipo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Componente</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Mecanismo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Método</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Tipo de hallazgo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Ruta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Orden</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Estado</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Realiz.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fecha prog.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fecha real</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>lubricante</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cant.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Unidad</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Min.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Reporta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Ejecuta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Observaciones</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>QR Mecanismo</th>
                    </tr>
                  </thead>
                  <ListaHa list={listH} />
                </table>
                <p></p>
              </div>
              <hr></hr>
            </div> */}
        </Form>           
      </div>
    )
  }
};

export default compose(
  graphql(queries.query.allOrdenRtes, {name:'allOrdenRtes',
    options: (props) => {return {variables: {tipoqry: `[{$sort: {numeroOrden: -1}}, {$limit : 100}]`}}}}),
  graphql(queries.query.allOrdenRtes, {name:'allOrdenRtesH',
    options: (props) => {return {variables: {tipoqry: `[{$sort: {numeroOrden: -1}}, {$limit : 100}]`}}}}),
  graphql(queries.query.allOrdenRtes, {name:'allOrdenRtesH1',
    options: (props) => {return {variables: {tipoqry: `[{$sort: {numeroOrden: -1}}, {$limit : 100}]`}}}}),
  graphql(queries.query.allOrdenRtes, {name:'allOrdenRtesH2',
    options: (props) => {return {variables: {tipoqry: `[{$sort: {numeroOrden: -1}}, {$limit : 100}]`}}}}),
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtesQR',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'XXX'}}]`}}}}),
    graphql(queries.query.allEmpresa, {name:'allEmpresa'}),
  graphql(queries.query.allEmpresaRtes, {name:'allEmpresaRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'descrEmpresa': {$ne: 'Seleccionar Empresa...'}}}]`}}}}),
  graphql(queries.query.allEmpresaRtes, {name:'allEmpresaRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'descrEmpresa': {$ne: 'Seleccionar Empresa...'}}}]`}}}}),
  graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipo: 'Técnico', estado: 'Activo'}}, {$sort: {nombreUsuario: 1}}]`}}}}),
  graphql(queries.query.allUsuariosRtes, {name:'allUsuariosRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipo: 'Técnico', estado: 'Activo'}}, {$sort: {nombreUsuario: 1}}]`}}}}),  
  
    graphql(queries.mutation.fecha, {name:'fecha'}),

)(ProgBitacoraNueva2)
